import type { FC } from 'react';
import * as Styled from './styled';
import type { CardProps } from './types';

export * from './types';

export const Card: FC<CardProps> = (props) => {
  const {
    size = 'medium',
    children,
    noPadding = false,
    isModal = false,
    containerProps,
    ...rest
  } = props;

  return (
    <Styled.Wrapper size={size} isModal={isModal} {...rest}>
      <Styled.Container size={size} noPadding={noPadding} isModal={isModal} {...containerProps}>
        {children}
      </Styled.Container>
    </Styled.Wrapper>
  );
};
